import { lazy, Suspense } from 'react'
import { BrowserRouter, Route, Routes } from 'react-router-dom'
import { ThemeVars } from '@/components/ThemeVars'
import { ContentProvider, useContent } from '@/lib/ContentContext'
import Landing from '@/pages/Landing'

// Admin은 방문자 번들에 포함될 필요가 없으므로 분리 로딩한다.
const AdminApp = lazy(() => import('@/admin/AdminApp'))
// 뷰어 래퍼도 랜딩 첫 로딩에는 필요 없다.
const Viewer = lazy(() => import('@/pages/Viewer'))
const Brochure = lazy(() => import('@/pages/Brochure'))

function Shell() {
  const { content } = useContent()
  return (
    <>
      <ThemeVars theme={content.theme} seo={content.seo} />
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route
          path="/admin/*"
          element={
            <Suspense
              fallback={<div className="p-10 text-sm text-ink-secondary">Loading Admin…</div>}
            >
              <AdminApp />
            </Suspense>
          }
        />
        {/* Studio 갤러리 카드가 새 탭으로 여는 래퍼 페이지.
            등록된 HTML로 바로 가지 않고 이 페이지의 iframe 안에 담아
            주소창에 뷰어 파일 경로가 드러나지 않게 한다. */}
        <Route
          path="/viewer/:id"
          element={
            <Suspense
              fallback={
                <div className="grid min-h-[100dvh] place-items-center text-sm text-ink-secondary">
                  Opening viewer…
                </div>
              }
            >
              <Viewer />
            </Suspense>
          }
        />
        {/* 푸터의 브로슈어 버튼이 여는 페이지. 다운로드 진행률을 보여준다. */}
        <Route
          path="/brochure"
          element={
            <Suspense
              fallback={
                <div className="grid min-h-[100dvh] place-items-center text-sm text-ink-secondary">
                  Opening brochure…
                </div>
              }
            >
              <Brochure />
            </Suspense>
          }
        />
        <Route path="*" element={<Landing />} />
      </Routes>
    </>
  )
}

export default function App() {
  return (
    <BrowserRouter>
      <ContentProvider>
        <Shell />
      </ContentProvider>
    </BrowserRouter>
  )
}
